import {useEffect, useState} from 'react';

function useServerIP() {
  const [ip, setIP] = useState(null);

  useEffect(() => {
    fetch('https://pl.ai-dente.com/get-ip.php') // get-ip.php має знаходитись в директорії www
      .then(res => res.json())
      .then(data => setIP(data.ip))
      .catch(err => {
        console.error('Failed to fetch IP address:', err);
        setIP('Failed to fetch IP address');
      });
  }, []);

  return ip;
}

export default useServerIP;
